/** @jsxImportSource @emotion/react */
import { Route, Routes } from 'react-router-dom';
import { TriggeredRules } from './components';

export const RulesEngineRouter = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<TriggeredRules />} />
      </Routes>
    </>
  );
};
